<div class="flex-1 flex-col align-end-stretch">
    <div class="state">
        {{'Carregando componentes do HTML5' | translate}}...
    </div>
    <mat-progress-bar mode="determinate" color="accent" [value]="progress()"></mat-progress-bar>
</div>
